// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "main-static/js/" + chunkId + "." + {"236":"8ca4e683","317":"58f3b330","373":"264f5af8","551":"20f3c439","580":"f4ec8a35","725":"23c047a0","745":"05c2a3b1","763":"2a27a1be","929":"dbe33d57","960":"43052ebb","968":"d38c63f5"}[chunkId] + ".chunk.js";
};